import { Col, Container, Row } from "reactstrap"

const IntvLayout = ({ top, bottom, currIntv }) => {

    return (
        <Container fluid={true} className="intv-container">
            <Row className="intv-row">
                <Col md="12" className="intv-col">
                   {top}
                </Col>
            </Row>
            <Row className="intv-status-row">
                <Col md="12" className="intv-status-col">
                   {bottom}
                </Col>
            </Row>
        </Container>
    )
}

export default IntvLayout